
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import RecruitPage from '../pages/recruit/page';
import BlogPage from '../pages/blog/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/recruit',
    element: <RecruitPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
